"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSSL007_List = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const server_1 = require("../../../server");
const account_1 = require("../../base/account");
const action_1 = require("../../menu/action");
const layout_1 = require("../../base/layout");
const DSSL007_List_Child_1 = require("./DSSL007_List_Child");
const functions_1 = require("./functions");
const popup_1 = require("../../base/popup");
const ScoreReportViewer_1 = require("../../DST/DSTL001/component/DSTL001_Detail_Child/ScoreReportViewer");
const DSSL007ListStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: center;
	justify-content: flex-start;
	flex: 1;
	position: relative;
	overflow-y: ${props => (props.$isAdmin ? '' : 'auto')};
	width: 100%;
	height: 100%;

	${({ $isTablet }) => $isTablet && `padding: 20px;`}

	${({ $isMobile }) => $isMobile &&
    `
		padding: 18px;
		.empty_data {
			min-height: 64px;
		}
	`}

	.download-btn {
		padding: 12px 24px;
	}

	.report-student-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 28px;
	}

	.report-top {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: 12px;
		flex-wrap: wrap;
	}

	.report-top-right {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-left: auto;
		${props => (props.$isMobile) &&
    `
			width: 100%;
			margin-left: 0;
			gap: 10px;
			flex-wrap: wrap;
		`}
	}

	/* 기간 필터 — 전역 .date-field 위 화면별 보정 (모바일: 인풋 2개 가로 균등) */
	.date-field.report-period-filter {
		${props => props.$isMobile &&
    `
			flex: 1;
			min-width: 0;
			input {
				flex: 1;
				width: 100% !important;
				min-width: 0;
			}
		`}
	}

	.report-title {
		font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
		font-size: ${props => (props.$isMobile || props.$isTablet ? '20px' : '24px')};
		line-height: 130%;
		letter-spacing: -0.02em;
		font-weight: 800;
		color: var(--color-black, #101010);
	}

	.summary-list {
		width: 100%;
		display: flex;
		gap: 16px;
		flex-wrap: wrap;
	}

	.summary-list .summary-item {
		flex: 1;
		min-width: ${props => (props.$isDesktop ? '280px' : '100%')};
	}

	.study-history-title {
		font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
		font-size: ${props => (props.$isMobile || props.$isTablet ? '20px' : '24px')};
		line-height: 130%;
		letter-spacing: -0.02em;
		font-weight: 800;
		color: var(--color-black, #101010);
	}

	.report-tab-layout {
		gap: 14px;
		align-items: flex-start;
		${props => (props.$isMobile || props.$isTablet) &&
    `
			gap: 10px;
		`}
	}

	.report-tab-layout .tab-layout-header {
		align-items: flex-end;
	}

	.report-tab-list {
		padding: 4px;
		display: inline-flex;
		width: fit-content;
		max-width: 100%;
		margin-right: auto;
		justify-content: flex-start;
		${props => (props.$isMobile) &&
    `
			width: 100%;
		`}
	}

	.report-tab-content {
		width: 100%;
	}

	.report-tab-guide {
		color: var(--color-grey-w, #b6bac0);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${props => (props.$isMobile ? '12px' : '16px')};
		line-height: 150%;
		letter-spacing: -0.02em;
		white-space: nowrap;
	}

	${props => props.$isMobile &&
    `
	.report-tab-guide {
		display: none;
	}
	`}

	.report-content {
		display: flex;
		flex-direction: column;
		gap: 40px;
		${props => (props.$isMobile || props.$isTablet) &&
    `
			gap: 28px;
		`}
	}

	.report-summary {
		display: flex;
		flex-direction: column;
		gap: 24px;
		${props => (props.$isMobile || props.$isTablet) &&
    `
			gap: 16px;
		`}
	}

	.report-detail {
		display: flex;
		flex-direction: column;
		gap: 24px;
		${props => (props.$isMobile || props.$isTablet) &&
    `
			gap: 16px;
		`}
	}

`;
const sortByDateDesc = (items) => [...(items || [])].sort((a, b) => (0, moment_1.default)(b?.startline || b?.last_streaming_play_time || 0).valueOf() -
    (0, moment_1.default)(a?.startline || a?.last_streaming_play_time || 0).valueOf());
exports.DSSL007_List = react_1.default.memo(({ isAdmin = false, classId, selectUserId, reportTitle, }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const userIdFromStore = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const user_id = selectUserId || userIdFromStore;
    const reportFetchSeqRef = (0, react_1.useRef)(0);
    // 조회 기간 직접 지정 — 미입력(빈 값)은 전체 조회(파라미터 생략, 기존 '전체' 동작)
    const [startDate, setStartDate] = (0, react_1.useState)('');
    const [endDate, setEndDate] = (0, react_1.useState)('');
    const [activeStudentTab, setActiveStudentTab] = (0, react_1.useState)('attend');
    // 지정한 기간을 그대로 start_after/start_before 로 전달 — 한쪽만 입력 시 그쪽만 전달(서버 파라미터 독립 옵셔널)
    const reportDateFilter = (0, react_1.useMemo)(() => {
        const filter = {};
        if (startDate && (0, moment_1.default)(startDate).isValid()) {
            filter.start_after = (0, moment_1.default)(startDate).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
        }
        if (endDate && (0, moment_1.default)(endDate).isValid()) {
            filter.start_before = (0, moment_1.default)(endDate).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
        }
        return filter;
    }, [startDate, endDate]);
    const [attendStatus, setAttendStatus] = (0, react_1.useState)({
        testData: [],
        totalCount: 0,
        done: 0,
        late: 0,
    });
    const [testGrade, setTestGrade] = (0, react_1.useState)({ testData: [], totalCount: 0, done: 0 });
    const [assignmentGrade, setAssignmentGrade] = (0, react_1.useState)({
        testData: [],
        totalCount: 0,
        done: 0,
    });
    const { data: testData, refetch: testRefetch } = (0, server_1.useGradeCardList)({
        id: user_id,
        ...reportDateFilter,
        assignment: false,
    });
    const { data: assignmentData, refetch: assignmentRefetch } = (0, server_1.useGradeCardList)({
        id: user_id,
        ...reportDateFilter,
        assignment: true,
    });
    const { data: conferenceData, refetch: conferenceRefetch } = (0, server_1.useConferenceReport)({
        id: user_id,
        ...reportDateFilter,
        // p.31: 출결(학습 요약/내역)은 수업만 집계 — 테스트(mock_test) 등 conference 혼입 제외 (SB 기준)
        type: server_1.LESSON_CONFERENCE_TYPES,
    });
    (0, react_1.useEffect)(() => {
        if (!user_id)
            return;
        let isMounted = true;
        const seq = ++reportFetchSeqRef.current;
        const fetchReports = async () => {
            await APP.eventManager.publish('SHOW_LOADING', true);
            try {
                await Promise.allSettled([testRefetch(), conferenceRefetch(), assignmentRefetch()]);
            }
            finally {
                if (isMounted && reportFetchSeqRef.current === seq) {
                    await APP.eventManager.publish('SHOW_LOADING', false);
                }
            }
        };
        fetchReports();
        return () => {
            isMounted = false;
        };
    }, [user_id, startDate, endDate, classId, testRefetch, conferenceRefetch, assignmentRefetch]);
    (0, react_1.useEffect)(() => {
        if (testData) {
            const { items, total_count: totalCount, done } = testData;
            setTestGrade({ testData: sortByDateDesc(items), totalCount, done });
        }
    }, [testData]);
    (0, react_1.useEffect)(() => {
        if (assignmentData) {
            const { items, total_count: totalCount, done } = assignmentData;
            setAssignmentGrade({ testData: sortByDateDesc(items), totalCount, done });
        }
    }, [assignmentData]);
    (0, react_1.useEffect)(() => {
        if (conferenceData) {
            const { items = [], total_count: totalCount, done, late = 0 } = conferenceData;
            // p.31: 출결은 '수업'만 집계. conference-report 가 type 필터를 적용하지 않으므로
            // 클라이언트에서 테스트 conference(mock_test)를 제외한다.
            // 테스트가 실제로 제외된 경우에만 요약 카운트(총/출석/지각)도 재계산(미제외 시 서버값 유지).
            const lessonItems = (items || []).filter((it) => !server_1.TEST_CONFERENCE_TYPE.includes(it?.type));
            const removed = (items || []).length - lessonItems.length;
            if (removed > 0) {
                const isLate = (it) => it?.status === 'late' || it?.attendance_status === 'late' || it?.late === true;
                setAttendStatus({
                    testData: sortByDateDesc(lessonItems),
                    totalCount: lessonItems.length,
                    // 하단 [학습 내역](StatusTable getAttendanceState)은 지각 → 출석 → 결석 순으로
                    // 판정하므로, 출석 집계도 지각을 배제해 같은 기준을 유지한다.
                    // (지각 항목은 done=false 라 현재 데이터에선 결과가 같지만, 둘 다 참인 항목이
                    //  생겨도 요약이 내역과 어긋나지 않도록 못 박아 둔다)
                    done: lessonItems.filter((it) => it?.done && !isLate(it)).length,
                    late: lessonItems.filter(isLate).length,
                });
            }
            else {
                setAttendStatus({ testData: sortByDateDesc(items), totalCount, done, late });
            }
        }
    }, [conferenceData]);
    // 시작일 변경 — 시작일이 종료일보다 늦으면 종료일을 시작일로 보정 (QnA DateRangeSelector 관례)
    const handlerStartDate = (value) => {
        setStartDate(value);
        if (value && endDate && (0, moment_1.default)(value).isAfter((0, moment_1.default)(endDate))) {
            setEndDate(value);
        }
    };
    // 종료일 변경 — 종료일이 시작일보다 빠르면 시작일로 보정
    const handlerEndDate = (value) => {
        if (value && startDate && (0, moment_1.default)(value).isBefore((0, moment_1.default)(startDate))) {
            setEndDate(startDate);
            return;
        }
        setEndDate(value);
    };
    const handlerScoreClick = (item, tabType) => {
        if (tabType === 'attend')
            return;
        const targetId = item?.test_id || item?.id;
        if (!targetId)
            return;
        dispatch((0, action_1.updateMenu)('myRoom', { menu: tabType === 'test' ? 'test' : 'assignment', detail: 'detail' }, targetId, {
            initialBigTab: 'testResult',
            fromStudyReport: true,
            reportSection: tabType,
        }));
    };
    // 출결 집계 매핑(전체 현황 스펙 — 교사 리포트 DSTL006 과 동일):
    //   출석 = done / 지각 = late / 결석 = 대상 − 출석 − 지각
    // conference-report 의 done 은 done=true 인 항목 수이고, 지각 항목은 done=false 다
    // (StatusTable getAttendanceState 가 지각 → 출석 → 결석 순으로 판정하는 것과 같은 기준).
    // 따라서 done 에서 late 를 다시 빼면 출석이 지각 수만큼 줄고 그만큼 결석으로 잡혀
    // 하단 [학습 내역]과 상단 [학습 요약]이 어긋났다(예: 출석3·지각1 → 출석2·지각1·결석1).
    const attendLateCount = attendStatus.late;
    const attendDoneCount = attendStatus.done;
    const attendAbsentCount = Math.max(0, attendStatus.totalCount - attendDoneCount - attendLateCount);
    // 출석률 산정 기준: 지각도 출석으로 인정한다(지각 처리 관련 학생 문의 다발 → 기준 변경 요청).
    // 카드의 %와 막대그래프(SummaryBox 의 value/max)가 같은 분자를 써야 하므로 함께 사용한다.
    // 아래 breakdown(출석·지각·결석)은 그대로 분리 표시 — 집계 자체는 바뀌지 않고 '비율'만 바뀐다.
    const attendRateCount = attendDoneCount + attendLateCount;
    const studentSummaryCards = (0, react_1.useMemo)(() => [
        {
            key: 'attend',
            title: '출석률',
            color: '#8BC3D0',
            total: attendStatus.totalCount,
            done: attendRateCount,
            percentage: attendStatus.totalCount > 0 ? (attendRateCount / attendStatus.totalCount) * 100 : 0,
            subTitle: (react_1.default.createElement(react_1.default.Fragment, null,
                "\uCD1D ",
                attendStatus.totalCount,
                "\uD68C \uC911",
                react_1.default.createElement("b", { className: "summary-first-metric" },
                    "\uCD9C\uC11D ",
                    attendDoneCount),
                " \u00B7 ",
                react_1.default.createElement("b", null,
                    "\uC9C0\uAC01 ",
                    attendLateCount),
                " \u00B7 ",
                react_1.default.createElement("b", null,
                    "\uACB0\uC11D ",
                    attendAbsentCount))),
        },
        {
            key: 'test',
            title: '테스트 응시율',
            color: '#8BC3D0',
            total: testGrade.totalCount,
            done: testGrade.done,
            percentage: testGrade.totalCount > 0 ? (testGrade.done / testGrade.totalCount) * 100 : 0,
            subTitle: (react_1.default.createElement(react_1.default.Fragment, null,
                "\uCD1D ",
                testGrade.totalCount,
                "\uD68C \uC911",
                react_1.default.createElement("b", { className: "summary-first-metric" },
                    "\uC751\uC2DC ",
                    testGrade.done),
                " \u00B7 ",
                react_1.default.createElement("b", null,
                    "\uBBF8\uC751\uC2DC ",
                    Math.max(0, testGrade.totalCount - testGrade.done)))),
        },
        {
            key: 'task',
            title: '과제 응시율',
            color: '#8BC3D0',
            total: assignmentGrade.totalCount,
            done: assignmentGrade.done,
            percentage: assignmentGrade.totalCount > 0
                ? (assignmentGrade.done / assignmentGrade.totalCount) * 100
                : 0,
            subTitle: (react_1.default.createElement(react_1.default.Fragment, null,
                "\uCD1D ",
                assignmentGrade.totalCount,
                "\uD68C \uC911",
                react_1.default.createElement("b", { className: "summary-first-metric" },
                    "\uC751\uC2DC ",
                    assignmentGrade.done),
                " \u00B7 ",
                react_1.default.createElement("b", null,
                    "\uBBF8\uC751\uC2DC ",
                    Math.max(0, assignmentGrade.totalCount - assignmentGrade.done)))),
        },
    ], [
        attendStatus.totalCount,
        attendDoneCount,
        attendLateCount,
        attendAbsentCount,
        attendRateCount,
        testGrade.totalCount,
        testGrade.done,
        assignmentGrade.totalCount,
        assignmentGrade.done,
    ]);
    const pdfSummaryCards = (0, react_1.useMemo)(() => [
        {
            key: 'attend',
            title: '출석률',
            total: attendStatus.totalCount,
            done: attendRateCount,
            percentage: attendStatus.totalCount > 0 ? (attendRateCount / attendStatus.totalCount) * 100 : 0,
            summaryLine: `출석 ${attendDoneCount} · 지각 ${attendLateCount} · 결석 ${attendAbsentCount}`,
        },
        {
            key: 'test',
            title: '테스트 응시율',
            total: testGrade.totalCount,
            done: testGrade.done,
            percentage: testGrade.totalCount > 0 ? (testGrade.done / testGrade.totalCount) * 100 : 0,
            summaryLine: `응시 ${testGrade.done} · 미응시 ${Math.max(0, testGrade.totalCount - testGrade.done)}`,
        },
        {
            key: 'task',
            title: '과제 응시율',
            total: assignmentGrade.totalCount,
            done: assignmentGrade.done,
            percentage: assignmentGrade.totalCount > 0
                ? (assignmentGrade.done / assignmentGrade.totalCount) * 100
                : 0,
            summaryLine: `응시 ${assignmentGrade.done} · 미응시 ${Math.max(0, assignmentGrade.totalCount - assignmentGrade.done)}`,
        },
    ], [
        attendStatus.totalCount,
        attendDoneCount,
        attendLateCount,
        attendAbsentCount,
        attendRateCount,
        testGrade.totalCount,
        testGrade.done,
        assignmentGrade.totalCount,
        assignmentGrade.done,
    ]);
    const pdfSections = (0, react_1.useMemo)(() => [
        {
            id: 'attend',
            title: '출결',
            studentType: 'attend',
            testData: attendStatus.testData,
            totalCount: attendStatus.totalCount,
            done: attendStatus.done,
        },
        {
            id: 'test',
            title: '테스트',
            studentType: 'test',
            testData: testGrade.testData,
            totalCount: testGrade.totalCount,
            done: testGrade.done,
        },
        {
            id: 'task',
            title: '과제',
            studentType: 'task',
            testData: assignmentGrade.testData,
            totalCount: assignmentGrade.totalCount,
            done: assignmentGrade.done,
        },
    ], [
        attendStatus.testData,
        attendStatus.totalCount,
        attendStatus.done,
        testGrade.testData,
        testGrade.totalCount,
        testGrade.done,
        assignmentGrade.testData,
        assignmentGrade.totalCount,
        assignmentGrade.done,
    ]);
    const handleDownloadPdf = (0, react_1.useCallback)(async () => {
        const pdfData = await (0, functions_1.openStudyReportPdf)({
            summaryCards: pdfSummaryCards,
            sections: pdfSections,
        });
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: ScoreReportViewer_1.ScoreReportViewer,
            componentProps: {
                pdfData,
                filename: 'study-report.pdf',
                title: 'study-report',
                onDownload: () => (0, functions_1.downloadPdf)({ summaryCards: pdfSummaryCards, sections: pdfSections }),
            },
            title: '학습 리포트',
            width: 900,
        });
    }, [pdfSummaryCards, pdfSections]);
    const studentHistorySections = [
        {
            id: 'attend',
            title: '출결',
            content: (react_1.default.createElement(DSSL007_List_Child_1.StatusTable, { studentType: "attend", testData: attendStatus.testData, totalCount: attendStatus.totalCount, showGuide: false, onScoreClick: handlerScoreClick })),
        },
        {
            id: 'test',
            title: '테스트',
            content: (react_1.default.createElement(DSSL007_List_Child_1.StatusTable, { studentType: "test", testData: testGrade.testData, totalCount: testGrade.totalCount, onScoreClick: handlerScoreClick })),
        },
        {
            id: 'task',
            title: '과제',
            content: (react_1.default.createElement(DSSL007_List_Child_1.StatusTable, { studentType: "task", testData: assignmentGrade.testData, totalCount: assignmentGrade.totalCount, onScoreClick: handlerScoreClick })),
        },
    ];
    const tabs = studentHistorySections.map(section => ({
        id: section.id,
        title: section.title,
        content: section.content,
    }));
    return (react_1.default.createElement(DSSL007ListStyled, { "$isAdmin": isAdmin, "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop, className: `dss007_list${isAdmin ? '' : ' wrapper-padding'}` },
        react_1.default.createElement("div", { className: "report-student-wrap" },
            react_1.default.createElement("div", { className: "report-top" },
                reportTitle && react_1.default.createElement("p", { className: "report-title" }, reportTitle),
                react_1.default.createElement("div", { className: "report-top-right" },
                    react_1.default.createElement("div", { className: "date-field report-period-filter" },
                        react_1.default.createElement("input", { type: "date", value: startDate, max: endDate || '9999-12-31', onChange: e => handlerStartDate(e.target.value) }),
                        react_1.default.createElement(common_1.Icon, { icon: "dash", width: 12 }),
                        react_1.default.createElement("input", { type: "date", value: endDate, min: startDate || undefined, max: "9999-12-31", onChange: e => handlerEndDate(e.target.value) })),
                    react_1.default.createElement(common_1.Button, { className: "btn_default xmd download-btn", text: "common.print", onClick: handleDownloadPdf }))),
            react_1.default.createElement("div", { className: "pdf-download" },
                react_1.default.createElement("div", { className: "report-content" },
                    react_1.default.createElement("div", { className: "report-summary" },
                        react_1.default.createElement("div", { className: "report-title" }, "\uD559\uC2B5 \uC694\uC57D"),
                        react_1.default.createElement("div", { className: "summary-list" }, studentSummaryCards.map(card => (react_1.default.createElement("div", { className: "summary-item", key: card.key },
                            react_1.default.createElement(DSSL007_List_Child_1.SummaryBox, { title: card.title, color: card.color, percentage: card.percentage, totalCount: card.total, done: card.done, subTitle: card.subTitle })))))),
                    react_1.default.createElement("div", { className: "report-detail" },
                        react_1.default.createElement("div", { className: "study-history-title" }, "\uD559\uC2B5 \uB0B4\uC5ED"),
                        react_1.default.createElement(layout_1.TabLayout, { className: "report-tab-layout", tabListClassName: "report-tab-list", contentClassName: "report-tab-content", tabs: tabs, activeTabId: activeStudentTab, onTabChange: setActiveStudentTab, equalButtonWidth: true, buttonSize: "md", headerRight: activeStudentTab !== 'attend' ? (react_1.default.createElement("div", { className: "report-tab-guide" }, "* \uC810\uC218 \uD074\uB9AD \uC2DC \uC0C1\uC138 \uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4")) : null })))))));
});
